import { api } from "./api";

export const analyticsApi = (params) => {
  return api.get(`/manufacturer/analytics`, {
    params,
  });
};

export const analyticsCheckerApi = (params) => {
  return api.get(`/manufacturer/analytics/analytics-checker`, {
    params,
  });
};

export const divisionListApi = () => {
  return api.get(`/manufacturer/analytics/division-list`);
};

export const productListApi = (params) => {
  return api.get(`/manufacturer/analytics/product-list`, { params });
};

export const fieldForceListApi = (params) => {
  return api.get(`/manufacturer/analytics/field-force-user-list`, { params });
};

export const distributorListApi = (params) => {
  return api.get(`/manufacturer/analytics/distributor-list`, { params });
};

export const pharmacyListApi = (params) => {
  return api.get(`/manufacturer/analytics/pharmacy-list`, { params });
};

export const doctorListApi = (params) => {
  return api.get(`/manufacturer/analytics/doctor-list`, { params });
};

export const headquaterListApi = (params) => {
  return api.get(`/manufacturer/analytics/head-quater/list`, { params });
};
